// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__S9D6a","validationTips":"StatementDescriptor_validationTips__167Ap"};